import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initErrorCapture } from "./lib/bugReportUtils";
import { GlobalErrorBoundary } from "./components/GlobalErrorBoundary";

// Start capturing JS errors for bug reports
initErrorCapture();

createRoot(document.getElementById("root")!).render(
  <GlobalErrorBoundary>
    <App />
  </GlobalErrorBoundary>
);
